import { ListPageSkeleton } from '@/components/PageSkeleton';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { useUserStore } from '@/stores/userStore';

/** 账户消耗代码加载时保留汇总卡片、快捷日期和初始无分页布局 */
export function AccountConsumptionSkeleton() {
  const permissionCodes = useUserStore((state) => state.userInfo?.permissionCodes);
  const canExport = permissionCodes?.includes('business:account_consumption:export');

  return (
    <div className="p-6 bg-muted/20 min-h-[700px] h-[780px] space-y-6" aria-hidden="true">
      {/** 总消耗金额、说明图标和金额占位 */}
      <Card>
        <CardContent className="p-6 flex items-center gap-2">
          <Skeleton className="h-7 w-28" />
          <Skeleton className="h-5 w-5 rounded-full" />
          <Skeleton className="h-7 w-40 ml-2" />
        </CardContent>
      </Card>

      <ListPageSkeleton
        columnCount={6}
        showPagination={false}
        contentClassName="gap-0 p-6"
        filterArea={
          <div className="flex items-end justify-between gap-4 pb-4">
            <div className="flex-1">
              <div className="flex flex-wrap items-center gap-4">
                {/** 今日、昨日、近7天和近1个月快捷日期 */}
                <div className="flex w-fit items-stretch">
                  <Skeleton className="h-9 w-16 rounded-r-none" />
                  <Skeleton className="h-9 w-16 rounded-none" />
                  <Skeleton className="h-9 w-18 rounded-none" />
                  <Skeleton className="h-9 w-21 rounded-l-none" />
                </div>
                {/** 日期、开户主体、账户和媒体平台 */}
                <Skeleton className="h-9 w-[260px]" />
                <Skeleton className="h-9 w-[220px]" />
                <Skeleton className="h-9 w-[180px]" />
                <Skeleton className="h-9 w-[180px]" />
                <div className="flex items-center gap-2">
                  <Skeleton className="h-9 w-20" />
                  <Skeleton className="h-9 w-20" />
                </div>
              </div>
            </div>
            <div className="flex gap-4">
              {/** 导出入口沿用页面权限，列配置始终保留 */}
              {canExport && <Skeleton className="h-9 w-20 ml-auto" />}
              <Skeleton className="h-9 w-24 shrink-0" />
            </div>
          </div>
        }
      />
    </div>
  );
}
